// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"VytalHeader_closeButton__EOdvN"};